import { JSONSerializable } from './storageListeners';

function getStorageValueSafely<Value extends JSONSerializable>(storage: Storage, key: string): Value | null {
    try {
        const storageValue = storage.getItem(key);
        if (storageValue != null) {
            return JSON.parse(storageValue);
        }
    } catch (error) {
        console.error('Error getting storage value', error);
    }
    return null;
}

function setStorageValueSafely<Value extends JSONSerializable>(storage: Storage, key: string, value: Value): void {
    try {
        if (value != null) {
            storage.setItem(key, JSON.stringify(value));
        } else {
            storage.removeItem(key);
        }
    } catch (error) {
        console.error('Error setting storage value', error);
    }
}

export { getStorageValueSafely, setStorageValueSafely };
